import React from 'react';

import { BaseIcon } from '@/shared/assets/icons/base-icon/base-icon';
import { TBaseIcon } from '@/shared/assets/icons/base-icon/base-icon.types';
import { LogoIconDarkArt } from '@/shared/assets/icons/logo/logo-icon-dark-art';
import { LOGO_ICON_DARK_SVG } from '@/shared/assets/icons/logo/logo-icon-dark.const';

export const LogoIconDark: React.FC<TBaseIcon> = (props) => {
  return (
    <BaseIcon
      {...LOGO_ICON_DARK_SVG}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <LogoIconDarkArt />
    </BaseIcon>
  );
};

LogoIconDark.displayName = 'LogoIconDark';
